import { CommonModule, NgFor } from '@angular/common'
import { Component, inject, OnDestroy, OnInit } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { eps } from '../../../services/url.service'
import { distinctUntilChanged, filter, skip, startWith, Subject, take, takeUntil, tap } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { payrollSummaryActions, resetPayrollSummary } from '../../../store/payroll/payroll.actions'
import { selectPayrollSummary, selectLoading } from '../../../store/payroll/payroll.reducers'
import { selectSelectedUser } from '../../../store/user/user.reducer'
import { loadUserById } from '../../../store/user/user.actions'
import { User } from '../../../store/auth/auth.state'
import { PayrollSummaryService } from '../../../services/payroll-summary.service'
import { PayrollSummary } from '../../../store/payroll/payroll.state'
import { TaxSettingsService } from '../../../services/tax-settings.service'
import { taxSettingsActions } from '../../../store/tax-settings/tax-settings.actions'
import { selectFinancialYears } from '../../../store/tax-settings/tax-settings.reducers'

@Component({
  selector: 'app-payroll-summary',
  imports: [NgFor, CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './payroll-summary.component.html',
  styleUrl: './payroll-summary.component.scss'
})
export class PayrollSummaryComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private destroy$ = new Subject<void>()
  eps = eps
  employeeId = ''
  employeeName = ''
  financialYears: string[] = []
  selectedFinancialYear = new FormControl('', { nonNullable: true })
  payrollSummary$ = this.store.select(selectPayrollSummary).pipe(distinctUntilChanged())
  // user$ = this.store.select(selectSelectedUser)
  // user!: User
  joiningDate!: any
  private payrollSummaryService = inject(PayrollSummaryService)
  latestPayrollSummary!: PayrollSummary | null
  financialYears$ = this.store.select(selectFinancialYears)
  loading$ = this.store.select(selectLoading)
  constructor() {
    this.store.dispatch(resetPayrollSummary())
    this.selectedFinancialYear.setValue('', { emitEvent: false })
  }
  ngOnInit(): void {
    this.store.dispatch(resetPayrollSummary())
    this.selectedFinancialYear.reset('') // ✅ IMPORTANT
    const employeeId = this.route.snapshot.paramMap.get('id')
    if (employeeId) this.employeeId = employeeId
    else this.router.navigate([eps.hrm.employeePath, this.employeeId])
    // this.setupFinancialYears()
    this.listenForSelectionChanges()
    this.store.dispatch(loadUserById({ id: this.employeeId }))
    // this.user$.subscribe(user => {
    //   if (user) {
    //     console.log('Joining Date:', user.joiningDate)
    //     // You can now use user.joiningDate anywhere
    //   }
    // })
    this.setEmployeeName()
    // this.getFinancialYearsList(this.employeeId)

    this.payrollSummary$.subscribe(summary => {
      this.latestPayrollSummary = summary
    })
    this.store.dispatch(taxSettingsActions.loadFinancialYears())
    // this.financialYears$.pipe(takeUntil(this.destroy$)).subscribe(years => {
    //   if (years?.length === 1) {
    //     this.selectedFinancialYear.setValue(years[0].name)
    //   }
    // })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  // private setupFinancialYears(): void {
  //   const currentYear = new Date().getFullYear()
  //   const START_YEAR = 2023 // Adjust as needed

  //   for (let year = START_YEAR; year <= currentYear + 1; year++) {
  //     this.financialYears.unshift(`${year - 1}-${year}`)
  //   }
  //   if (this.financialYears.length > 0) {
  //     this.selectedFinancialYear.setValue(this.financialYears[0])
  //   }
  // }

  private setEmployeeName(): void {
    this.store
      .pipe(
        select(selectSelectedUser),
        filter((user): user is User => !!user),
        take(5)
      )
      .subscribe(user => {
        this.employeeName = user.firstName + ' ' + (user.lastName ?? '')
        this.joiningDate = user.joiningDate
      })
  }

  private listenForSelectionChanges(): void {
    this.selectedFinancialYear.valueChanges
      // .pipe(startWith(this.selectedFinancialYear.value))
      .pipe(
        takeUntil(this.destroy$),
        filter(year => !!year && !!this.employeeId),
        distinctUntilChanged(),
        tap(year => {
          this.store.dispatch(resetPayrollSummary()) // clear old

          this.store.dispatch(
            payrollSummaryActions.loadSummary({
              employeeId: this.employeeId,
              financialYear: year,
              joiningDate: this.joiningDate
            })
          )
        })
      )
      .subscribe()
  }

  // getFinancialYearsList(employeeId: string) {
  //   //let skip = this.currentPage * this.pageLimit - this.pageLimit
  //   //const search = this.search
  //   //  ? {
  //   //      $or: { title: { $like: `%${this.search}%` } },
  //   //      $and: { businessId: { $like: `%${this.selectedBusinessSort}%` } }
  //   //    }
  //   //  : {}
  //   this.payrollSummaryService.getHistoricalPayrollFinancialYearForEmployee(employeeId).subscribe({
  //     next: response => {
  //       this.financialYears = response
  //     },
  //     error: (error: { message: string }) => {
  //       console.warn('Error: ' + error.message)
  //     }
  //   })
  // }

  // get hasPastData(): boolean {
  //   const past = this.latestPayrollSummary?.past
  //   return !!(
  //     (past?.header?.length ?? 0) > 1 &&
  //     ((past?.earningsRows?.length ?? 0) > 0 ||
  //       (past?.deductionsRows?.length ?? 0) > 0 ||
  //       (past?.tdsRows?.length ?? 0) > 0 ||
  //       (past?.lopRows?.length ?? 0) > 0)
  //   )
  // }
}
